import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useCartIntermediateContext } from '../../hooks/useCartIntermediateContext'

type CartIntermediateShowDiscountedProductsButtonProps = {
  className?: string
}

export const CartIntermediateShowDiscountedProductsButton: FC<
  CartIntermediateShowDiscountedProductsButtonProps
> = ({ className }) => {
  const {
    specialOffersCollapsibleControls: { handleOpen },
  } = useCartIntermediateContext()

  return (
    <Button
      className={className}
      data-qa-id="continue-shopping-button"
      onClick={() => {
        handleOpen()
      }}
      variant="outlined"
    >
      <FormattedMessage id="cartIntermediate.drawer.specialOffers.button" />
    </Button>
  )
}
